import { useCallback, useRef, useState } from 'react';

import { useDisclosure } from '@bonusly/design-system';

import { Announcement } from '../types/announcements';

export const useAnnouncementPreview = () => {
	const modal = useDisclosure();
	const blobUrl = useRef<string>();
	const [previewAnnouncement, setPreviewAnnouncement] = useState<Announcement | null>(null);

	const revokeBlobUrl = useCallback(() => {
		if (blobUrl.current) {
			URL.revokeObjectURL(blobUrl.current);
			blobUrl.current = undefined;
		}
	}, []);

	const createBlobUrl = useCallback(
		(file: File | undefined): string | undefined => {
			revokeBlobUrl();
			if (!file) return undefined;
			const url = URL.createObjectURL(file);
			blobUrl.current = url;
			return url;
		},
		[revokeBlobUrl]
	);

	const openPreview = useCallback(
		(announcement: Announcement) => {
			setPreviewAnnouncement(announcement);
			modal.onOpen();
		},
		[modal]
	);

	const closePreview = useCallback(() => {
		revokeBlobUrl();
		setPreviewAnnouncement(null);
		modal.onClose();
	}, [modal, revokeBlobUrl]);

	return { isOpen: modal.isOpen, previewAnnouncement, openPreview, closePreview, createBlobUrl };
};
